// extracted by mini-css-extract-plugin
export var questionBox = "_al-0";